<div class="card carddborder">
  <div class="card-header">
    <div class="launch-header d-flex w-100 justify-content-between">
      <h5 class="mb-0">EKS Request Dashboard</h5>
      <div class="dashboard-header-actions">
        <button type="button" class="btn request-eks-btn" (click)="openRequestEksModal()">
          <span class="request-eks-btn__plus">+</span>
          Request EKS
        </button>
        <button class="btn btn-light" [disabled]="loading" (click)="loadRequests(true)">
          {{ loading ? "Loading..." : "Refresh" }}
        </button>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div *ngIf="loading && rows.length===0" class="mapping-box">Loading requests...</div>
    <div *ngIf="!loading && error" class="alert alert-danger mb-3">{{ error }}</div>

    <div *ngIf="!error" class="mapping-box">
      <table class="table table-sm mb-0 ec2-dashboard-table">
        <thead>
          <tr>
            <th class="col-sno">S No</th>
            <th class="col-instance">Cluster Name</th>
            <th class="col-requested-by">Requested By</th>
            <th class="col-stage">Stage</th>
            <th class="col-status">Status</th>
            <th class="col-result">Failed Reason</th>
            <th class="col-actions text-center"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of rows; let i = index">
            <td class="col-sno">{{ i + 1 }}</td>
            <td class="col-instance">{{ row.cluster_name || "-" }}</td>
            <td class="col-requested-by">{{ row.requested_by || "-" }}</td>
            <td class="col-stage">{{ row.stage || "-" }}</td>
            <td class="col-status">
              <span *ngIf="statusLoadingByRequestId[row.request_id]" class="tiny-loader"></span>
              {{ displayStatus(row) }}
            </td>
            <td class="col-result">{{ row.reason || "-" }}</td>
            <td class="col-actions">
              <div class="action-group">
                <a class="btn btn-sm btn-outline-primary details-btn" [routerLink]="['/dash/operations/eks-request', row.request_id]" [queryParams]="{ aws_account_id: accountId, region: row.region || region }">Details</a>
                <a
                  *ngIf="canAddNodeGroup(row)"
                  class="btn btn-sm btn-primary ms-2"
                  [routerLink]="['/dash/operations/eks-nodegroups', row.cluster_name]"
                  [queryParams]="nodeGroupQueryParams(row)"
                >
                  Node Group
                </a>
              </div>
            </td>
          </tr>
          <tr *ngIf="rows.length === 0 && !loading"><td colspan="7" class="text-center text-muted">No requests found.</td></tr>
        </tbody>
      </table>
    </div>

    <div class="step-footer mt-2" *ngIf="hasMore">
      <button class="btn btn-light" [disabled]="loading" (click)="loadRequests(false)">{{ loading ? 'Loading...' : 'Load More' }}</button>
    </div>
  </div>
</div>

<app-request-eks-modal
  [visible]="showRequestEksModal"
  [accountId]="accountId"
  [region]="region"
  [apiBaseUrl]="apiBaseUrl"
  [urlPrefix]="urlPrefix"
  (close)="closeRequestEksModal()"
  (submitted)="loadRequests(true)"
></app-request-eks-modal>
